export default __webpack_public_path__ + "static/media/NotoSans-Regular.12c5f3f9.woff2";